module.exports = __webpack_public_path__ + "static/media/snowy-4.474b6da7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/weather-icons/snowy-4.svg
// module id = 529
// module chunks = 0